/**
 * Máscara para CPF.
 *
 * Remove todos os caracteres não numéricos e insere pontuação no formato padrão:
 * `XXX.XXX.XXX-XX`.
 *
 * Exemplo:
 * ```ts
 * formartCPF("12345678901"); // "123.456.789-01"
 * ```
 *
 * @param {string} value - String contendo os dígitos do CPF.
 * @returns {string} CPF formatado como `XXX.XXX.XXX-XX`.
 */
const formartCPF = (value: string) =>
	value
		.replace(/\D/g, "")
		.replace(/(\d{3})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

const formartDocumet = {
	formartCPF,
};

export default formartDocumet;
